import { render } from "./GameTesting.vue?vue&type=template&id=132d2d2c&scoped=true&ts=true"
import script from "./GameTesting.vue?vue&type=script&lang=ts"
export * from "./GameTesting.vue?vue&type=script&lang=ts"

import "./GameTesting.vue?vue&type=style&index=0&id=132d2d2c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/octopus-lobby/octopus-lobby/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132d2d2c"]])

export default __exports__